// extracted by mini-css-extract-plugin
module.exports = {"section-1":"Targeting_section-1_33jeN","section-2":"Targeting_section-2_V0V9K","section-5":"Targeting_section-5_j-Fjz"};